import React from "react";
import Charge from "../component/sections/finance/Charge";
import OfficialInvoice from "../component/sections/finance/OfficialInvoice";
import Invoices from "../component/sections/finance/Invoices";
import Pledge from "../component/sections/finance/Pledge";
import AllTransaction from "../component/sections/finance/coworker/AllTransaction";
import AddTransaction from "../component/sections/finance/coworker/AddTransaction";
import ListCustomerForPledge from "../component/sections/finance/coworker/pledge/ListCustomerForPledge";

const financeRoutes = [
  {
    path: "/finance/charge",
    render: () => <Charge />,
    exact: true,
  },
  {
    path: "/finance/pledge",
    render: () => <Pledge />,
    exact: true,
  },
  {
    path: "/finance/invoices",
    render: () => <Invoices />,
    exact: true,
  },
  {
    path: "/finance/official/:id",
    render: () => <OfficialInvoice />,
    exact: true,
  },
  {
    path: "/finance/transaction",
    render: () => <AllTransaction />,
    exact: true,
  },
  {
    path: "/finance/add-transaction",
    render: () => <AddTransaction />,
    exact: true,
  },
  {
    path: "/finance/pledge/select-customer",
    render: () => <ListCustomerForPledge />,
    exact: true,
  },
];

export default financeRoutes;
